import React from "react";
import PropTypes from "prop-types";
import { Box, Grid } from "@mui/material";
import { useSelector } from "react-redux";

import messages from "../../../../../assets/locale/messages";
import "../../_EventDetailFields.scss";

const MarginCard = ({ label, value, unit }) => (
  <Grid item xs={6} sm={6} md={3}>
    <div className="event-detail-margin-card">
      <span className="event-detail-label">{label}</span>
      <span className="event-detail-value">
        {value != null ? `${value} ${unit}` : "—"}
      </span>
    </div>
  </Grid>
);

MarginCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unit: PropTypes.string.isRequired,
};

MarginCard.defaultProps = {
  value: null,
};

const CheckInMargins = ({ shift }) => {
  const lang = useSelector((state) => state.locale.lang);
  const { events, shared } = messages[lang];
  const t = events.viewEvents;

  return (
    <Box>
      <span className="event-detail-subsection-heading">{t.checkInOutMargins}</span>
      <Grid container spacing={2}>
        <MarginCard
          label={t.beforeStart}
          value={shift?.before_check_in_margin}
          unit={shared.minutes}
        />
        <MarginCard
          label={t.afterStart}
          value={shift?.after_check_in_margin}
          unit={shared.minutes}
        />
        <MarginCard
          label={t.beforeEnd}
          value={shift?.before_check_out_margin}
          unit={shared.minutes}
        />
        <MarginCard
          label={t.afterEnd}
          value={shift?.after_check_out_margin}
          unit={shared.minutes}
        />
      </Grid>
    </Box>
  );
};

CheckInMargins.propTypes = {
  shift: PropTypes.object,
};

CheckInMargins.defaultProps = {
  shift: null,
};

export default CheckInMargins;
